import faceNone from '@/assets/images/nps/faces/face-none.svg'
import face1 from '@/assets/images/nps/faces/face-1.svg'
import face2 from '@/assets/images/nps/faces/face-2.svg'
import face3 from '@/assets/images/nps/faces/face-3.svg'
import face4 from '@/assets/images/nps/faces/face-4.svg'
import face5 from '@/assets/images/nps/faces/face-5.svg'

/** Лица маскота по оценке; первое — пока оценка не поставлена. */
const FACES = [faceNone, face1, face2, face3, face4, face5]

/**
 * Лицо ромашки под текущую оценку.
 *
 * В макете лиц шесть: одно нейтральное и по одному на каждое деление шкалы.
 * Если шкалу расширят до 0–10, лиц не хватит — тогда растягиваем имеющиеся
 * на диапазон, чтобы крайние оценки всё равно получали крайние лица.
 */
export const getMascotFace = (
  score: number | null,
  min: number,
  max: number
): string => {
  if (score === null) return FACES[0]

  const grades = FACES.length - 1
  const steps = Math.max(max - min, 1)
  const index = 1 + Math.round(((score - min) / steps) * (grades - 1))
  return FACES[Math.min(Math.max(index, 1), grades)]
}
